
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Grid, Settings, Users, Clock, ListChecks } from 'lucide-react';
import { SidebarGroup, SidebarGroupContent, SidebarMenu } from '@/components/ui/sidebar';
import { SidebarMenuItem } from './SidebarMenuItem';
import { WorkspaceSidebarProps } from './types';

export const NavigationMenu = ({ onWorkspaceChange }: WorkspaceSidebarProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      title: t('common.sidebar.boards'),
      icon: <Grid className="h-4 w-4" />,
      path: '/dashboard',
      onClick: () => {
        onWorkspaceChange?.(undefined);
        navigate('/dashboard');
      }
    },
    {
      title: t('Organizer'),
      icon: <ListChecks className="h-4 w-4" />,
      path: '/organizer',
      onClick: () => navigate('/organizer')
    },
    {
      title: t('common.sidebar.members'),
      icon: <Users className="h-4 w-4" />,
      path: '/members',
      onClick: () => navigate('/members')
    },
    {
      title: t('Time Tracking'),
      icon: <Clock className="h-4 w-4" />,
      path: '/time-tracking',
      onClick: () => navigate('/time-tracking')
    },
    {
      title: t('common.sidebar.settings'),
      icon: <Settings className="h-4 w-4" />,
      path: '/settings',
      onClick: () => navigate('/settings')
    }
  ];

  return (
    <SidebarGroup className="mt-4">
      <SidebarGroupContent>
        <SidebarMenu>
          {menuItems.map((item) => (
            <SidebarMenuItem
              key={item.title}
              {...item}
              isActive={location.pathname === item.path}
            />
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
